;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function validateNationalNumber(maskedInput: string) {
  if (!maskedInput) return false;
  const n = maskedInput.replace(/[^0-9]/g, '');

  // RR numbers need to be 11 chars long
  if (n.length !== 11) return false;

  const checkDigit = parseInt(n.slice(-2));
  const modFunction = (nr) => 97 - (nr % 97);

  let nrToCheck = parseInt(n.slice(0, 9));

  // first check without 2
  if (modFunction(nrToCheck) === checkDigit) return true;

  // then check with 2 appended for y2k+ births
  nrToCheck = parseInt(`2${n.slice(0, 9)}`);

  const valid = modFunction(nrToCheck) === checkDigit;

  return valid;
}

export const nationalNumberPattern = [
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
];
